export default "__VITE_ASSET__De_3yWn9__"